import m from "../../geodata/es2015/nepalHigh";
window.am4geodata_nepalHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/nepalHigh.js
// module id = null
// module chunks = 